  if (!customElements.get('meyspring-community')) {
    class MeyspringCommunity extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.ms-community__track');
        this.slides = [...this.querySelectorAll('.ms-community__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.status = this.querySelector('.ms-community__status');
        this.index = 0;
        this.frame = 0;
        if (!this.slides.length) return;
        const controls = this.querySelector('.ms-community__controls');
        if (controls) controls.hidden = false;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.slide !== undefined) this.go(Number(button.dataset.slide));
          if (button.dataset.direction) this.go(this.index + Number(button.dataset.direction));
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const targets = { ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.slides.length - 1 };
          if (targets[event.key] === undefined) return;
          event.preventDefault();
          this.go(targets[event.key]);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const trackRect = this.track.getBoundingClientRect();
            let nearest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, index) => {
              const delta = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
              if (delta < distance) { distance = delta; nearest = index; }
            });
            this.update(nearest);
          });
        }, { passive: true, signal });
        this.sectionSelect = event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, false);
        };
        document.addEventListener('shopify:block:select', this.sectionSelect, { signal });
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, false));
        this.resizeObserver.observe(this.track);
        this.update(0);
      }
      go(index, animate = true) {
        const next = (index + this.slides.length) % this.slides.length;
        const delta = this.slides[next].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: delta, behavior: animate && !reduced ? 'smooth' : 'auto' });
        if (!animate) this.update(next);
      }
      update(index) {
        this.index = index;
        this.slides.forEach((slide, current) => {
          slide.inert = current !== index;
          slide.setAttribute('aria-hidden', String(current !== index));
        });
        this.dots.forEach((dot, current) => dot.setAttribute('aria-current', String(current === index)));
        const text = this.status.dataset.statusTemplate.replace('[current]', index + 1).replace('[total]', this.slides.length).replace('[artist]', this.slides[index].dataset.artist);
        if (this.status.textContent !== text) this.status.textContent = text;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.ready = false;
      }
    }
    customElements.define('meyspring-community', MeyspringCommunity);
  }
